import { createApiSlice } from "@common";
import { CRUD_WIN_LOSS_REASON } from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addWinLossReason",
    method: "post",
    url: CRUD_WIN_LOSS_REASON,
    stateKey: "message",
  },
  {
    name: "getWinLossReason",
    method: "get",
    url: CRUD_WIN_LOSS_REASON,
    stateKey: "data",
  },
  {
    name: "updateWinLossReason",
    method: "put",
    url: CRUD_WIN_LOSS_REASON,
    stateKey: "message",
  },
  {
    name: "deleteWinLossReason",
    method: "delete",
    url: CRUD_WIN_LOSS_REASON,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "winLossReason",
  apiConfig,
  customReducers,
);
const winLossReasonSlice = slice;

// Export the slice's reducer
export default winLossReasonSlice.reducer;

// Export thunks
export const {
  addWinLossReason,
  getWinLossReason,
  updateWinLossReason,
  deleteWinLossReason,
} = thunks;

// Export actions
export const { rowSelect } = actions;
